
const AUTH_REQUEST = (state, payload) => { state.status = "loading"; }

const AUTH_SUCCESS_NODE = (state, payload) => {
    state.status = "success";
    state.accessToken = payload.accessToken;
    state.place = payload.place;
    state.user.id = payload.id;
    state.user.uuid = payload.uuid;
    state.user.placeUuid = payload.place.uuid;
    state.user.placeName = payload.place.name;
    state.user.name = payload.name;
    state.user.username = payload.username;
    state.user.email = payload.email;
    state.params = payload.params;
    state.roles = payload.rules;
    state.hasLoadedOnce = true;
}

const SET_USER_DETAILS = (state, payload) => {
    state.user.paymentMethods = payload.paymentMethods
}

const AUTH_ERROR = (state, payload) => {
    state.status = "error";
    state.hasLoadedOnce = true;
}

const AUTH_LOGOUT = (state, payload) => {
    state.accessToken = "";
    state.user = {};
    state.roles = [];
    state.params = {};
    localStorage.removeItem('vuex')
}

const SET_ACCESS_TOKEN = (state, payload) => {
    state.accessToken = payload
}

export default {
    SET_ACCESS_TOKEN,
    SET_USER_DETAILS,

    AUTH_REQUEST,
    AUTH_SUCCESS_NODE,
    // AUTH_SUCCESS_CAKE,
    AUTH_ERROR,
    AUTH_LOGOUT,
}
